import Link from 'next/link';
import { signIn, SignInAuthorizationParams, SignInOptions, useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import styles from '@features/loginPage/LoginPage.styles';
import ActionBlock from '@features/loginPage/components/ActionBlock/ActionBlock';
import theme from '@styles/theme';
import Heading from '@components/Heading/Heading';
import { LOGIN_PAGE_IMG } from '@features/loginPage/const';
import Icon from '@components/icons/Icon';
import Loading from '@components/Loading/Loading';
import getPublicEnv from '@utils/getPublicEnv';
const LoginCheckout = ({
  handleRegister,
  viewType,
  redirectPath
}) => {
  const router = useRouter();
  const {
    locale
  } = router;
  const {
    t
  } = useTranslation(['user', 'common']);
  const {
    status
  } = useSession();
  const handleLogin = () => {
    // Zapisz informację o type=checkout w sessionStorage, aby zachować ją po powrocie z błędu
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('loginType', 'checkout');
    }
    const localePrefix = locale && locale !== router.defaultLocale ? `/${locale}` : '';
    const options: SignInOptions = {
      callbackUrl: `${localePrefix}${redirectPath}`
    };
    const authorizationParams: SignInAuthorizationParams | undefined = locale && locale !== router.defaultLocale ? {
      ui_locales: locale
    } : undefined;
    signIn('keycloak', options, authorizationParams);
  };
  if (status === 'unauthenticated') {
    return <>
        <div sx={styles.backToCart}>
          <Link href={viewType.goBackUrl}>
            <div sx={styles.backToCartHolder}>
              <Icon icon="ArrowBack" size="13.33px" color={theme.rawColors.darkGrey700} />
              <p sx={styles.backToCartText}>{t(viewType.goBackText, {
                ns: 'common'
              })}</p>
            </div>
          </Link>
        </div>
        <div sx={styles.section}>
          <div sx={styles.heading}>
            <Heading h={1} headingType={1} mobile align="center">
              {t(viewType.headerTitle)}
            </Heading>
          </div>

          <div sx={styles.blocksContainer}>
            <div sx={styles.authBlocks}>
              <div sx={styles.singleAuthBlocks(false)}>
                <ActionBlock heading={t('alreadyHaveAccount').replace('{{domain}}', getPublicEnv('NEXT_PUBLIC_HOST').replace('https://', ''))} description={t('loginHelloMessage')} buttonText={t('login')} buttonAction={handleLogin} buttonOutlined={false} cy="InitializeLoginButton" />
              </div>
              <div sx={styles.singleAuthBlocks(false)}>
                <ActionBlock heading={t(viewType.guestHeader)} description={t('doNotJoinForNow')} buttonText={t(viewType.guestButton)} buttonAction={() => {
                router.push({
                  pathname: redirectPath
                });
              }} buttonOutlined cy="GuestFinalizing" />
              </div>
            </div>
            <div sx={styles.newClientBlock}>
              <ActionBlock heading={t('newClient')} description={t('joinToday')} buttonText={t('register')} buttonAction={() => handleRegister()} buttonOutlined fullHeight image={LOGIN_PAGE_IMG} descriptionPoints={[t('registerAccountPoint1'), t('registerAccountPoint2')]} cy="CreateAccount" />
            </div>
          </div>
        </div>
      </>;
  }
  return <Loading />;
};
export default LoginCheckout;